export default __webpack_public_path__ + "static/media/icon-qr-passcoopeuch-googleplay.15e37e3d.png";